import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ButtonComponent } from "../../components/button/button.component";
import { HeaderComponent } from "../../components/header/header.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { CommonModule } from '@angular/common';
import { DropdownService } from '../../services/dropdown.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { ExamService } from '../../services/exam.service';
import { ValidationService } from '../../services/validation.service';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';

@Component({
  selector: 'app-exam-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, FilterByKeyAndValuePipe, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, SelectInputComponent, AgGridListComponent, BulkUploadComponent, SearchInputComponent,DropdownUploadButtonComponent],
  templateUrl: './exam-list-page.component.html',
  styleUrl: './exam-list-page.component.css'
})
export class ExamListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Exam';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any = [];
  show_menu = false;


  columns: any = [
    { headerName: 'Sr.No', field: 'SrNo', flex: 1 },
    { field: 'AcademicYear.name', headerName: 'Academic Year', filter: true, flex: 1, },
    { field: 'University.name', headerName: 'School', filter: true, flex: 1, },
    { field: 'College.name', headerName: 'School Branch', filter: true, flex: 1, },
    { field: 'Level.name', headerName: 'Level', filter: true, flex: 1, },
    { field: 'Program.name', headerName: 'Program', filter: true, flex: 1, },
    // { field: 'Subject.name', headerName: 'Subject', filter: true, flex: 1, },
    { field: 'Stream.name', headerName: 'Stream', filter: true, flex: 1, },
    { field: 'name', headerName: 'Exam Name', filter: true, flex: 1, },
    { field: 'code', headerName: 'Exam Code', filter: true, flex: 1, },
    { headerName: 'Contact Details', filter: true, flex: 2, valueGetter: (p: any) => [p.data?.contact, p.data?.email].filter(Boolean).join(`, `) },
    { field: 'is_active', headerName: 'Status', filter: true, flex: 1, valueGetter: (params: any) => params.data?.is_active, cellRenderer: (params: any) => { return params.value ? 'Enable' : 'Disable'; } },
    { headerName: "Actions", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 210, minWidth: 210, maxWidth: 210 }
  ];

  bulk_columns = [
    { column_name: 'Academic Year', type: 'link', linked_list: 'academic_list', return_as: 'academic_year_id', returning_key: 'id', sample_value: '2025-2026' },
    { column_name: 'School', type: 'link', linked_list: 'university_list', return_as: 'university_id', returning_key: 'id', sample_value: 'Test' },
    { column_name: 'School Branch', type: 'link', linked_list: 'college_list', return_as: 'college_id', returning_key: 'id', sample_value: 'Thakur' },
    { column_name: 'Level', type: 'link', linked_list: 'level_list', return_as: 'level_id', returning_key: 'id', sample_value: 'Test Level' },
    { column_name: 'Program', type: 'link', linked_list: 'program_list', return_as: 'program_id', returning_key: 'id', sample_value: 'Python' },
    // { column_name: 'Subject Name', type: 'link', linked_list: 'subject_list', return_as: 'subject_id', returning_key: 'id',sample_value: 'PG' },
    { column_name: 'Stream Name', type: 'link', linked_list: 'stream_list', return_as: 'stream_id', returning_key: 'id', sample_value: 'STREAM' },
    { column_name: 'Credits', type: 'text', return_as: 'credits', sample_value: '5', max_length: this.vs.max_length_credits, skip_validation: true },
    { column_name: 'Exam Name', type: 'text', return_as: 'name', sample_value: 'Data Base Management System', is_unique: true, min_length: 2, max_length: 150, regex: this.vs.name_pattern },
    { column_name: 'Exam Code', type: 'text', return_as: 'code', sample_value: 'DBMS001', min_length: 2, max_length: 10, regex: this.vs.code_pattern },
    { column_name: 'Contact Number', type: 'text', return_as: 'contact', sample_value: '9212948392', skip_validation: true, min_length: 10, max_length: 12 },
    { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'exam@gmail.com', skip_validation: true },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.evaluation_management_examinations_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.evaluation_management_examinations_view })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.evaluation_management_examinations_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.open_delete_modal.bind(this), permissions: this.gs.user_role_data?.evaluation_management_examinations_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public es: ExamService, public ar: ActivatedRoute, public dds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      academic_year_id: ['', [Validators.required]],
      university_id: ['', [Validators.required]],
      college_id: ['', [Validators.required]],
      level_id: ['', [Validators.required]],
      program_id: ['', [Validators.required]],
      // subject_id: ['', [Validators.required]],
      stream_id: ['', [Validators.required]],
      credits: ['', [Validators.pattern('^(?:[0-9]|1[0-9]|20)$')]],
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      contact: ['', [Validators.minLength(this.vs.min_length_contact), Validators.maxLength(this.vs.max_length_contact),]],
      email: ['', [Validators.pattern(this.vs.email_pattern), Validators.maxLength(this.vs.max_length_email)]],
      is_active: [true]
    });
  }
  async ngOnInit() {
    await this.dds?.get_dropdown_list(['academic-year', 'university', 'college', 'level', 'stream', 'program']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      await this.get_list(this.params)

    })
  }
  async get_list(filter?: any) {
    try {
      const res = await this.es.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async open_delete_modal(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  async delete() {
    try {
      let res = await this.es.delete(this.selected_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      this.dds.invalidate_dropdown_cache('exam');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      await this.es.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    this.dds.invalidate_dropdown_cache('exam');
    await this.get_list(this.params);
  }
  async open_form_modal(item?: any) {
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids.id) {
      let response = await this.es.get(item.id);
      this.selected_ids = this.gs.addHierarchyIds({ ...response.data });
      this.form.patchValue({
        academic_year_id: this.selected_ids.academic_year_id,
        university_id: this.selected_ids.university_id,
        level_id: this.selected_ids.level_id,
        stream_id: this.selected_ids.stream_id,
        credits: this.selected_ids.credits,
        name: this.selected_ids.name,
        code: this.selected_ids.code,
        contact: this.selected_ids.contact,
        email: this.selected_ids.email,
        is_active: this.selected_ids.is_active,
      });
      setTimeout(() => {
        this.form.patchValue({
          college_id: this.selected_ids.college_id,
          program_id: this.selected_ids.program_id,
        });
      });
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.es.update(this.selected_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.dds.invalidate_dropdown_cache('exam');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  open_view_modal(item: any) {
    console.log(item);
    this.selected_ids = item || {};
    this.view_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      let form_value = this.form.value;
      form_value.is_active = true;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.es.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.es.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.dds.invalidate_dropdown_cache('exam');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.es, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }
}
